/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Confirmed_By_HelpInputs */

const en_cad_confirmed_by_help = /** @type {(inputs: Cad_Confirmed_By_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name or phone number of the customer who confirmed — at least one is required.`)
};

const ja_cad_confirmed_by_help = /** @type {(inputs: Cad_Confirmed_By_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認した顧客の氏名または電話番号 — 少なくとも一方の入力が必要です。`)
};

const fr_cad_confirmed_by_help = /** @type {(inputs: Cad_Confirmed_By_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom ou numéro de téléphone du client qui a confirmé — au moins un des deux est requis.`)
};

const de_cad_confirmed_by_help = /** @type {(inputs: Cad_Confirmed_By_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name oder Telefonnummer des Kunden, der bestätigt hat — mindestens eine Angabe ist erforderlich.`)
};

/**
* | output |
* | --- |
* | "Name or phone number of the customer who confirmed — at least one is required." |
*
* @param {Cad_Confirmed_By_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_confirmed_by_help = /** @type {((inputs?: Cad_Confirmed_By_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Confirmed_By_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_confirmed_by_help(inputs)
	if (locale === "ja") return ja_cad_confirmed_by_help(inputs)
	if (locale === "fr") return fr_cad_confirmed_by_help(inputs)
	return de_cad_confirmed_by_help(inputs)
});